class AddFilesToSellingCard{
    id = 0;
    files = [];
}
export default AddFilesToSellingCard